import React from 'react';
import { Box, Typography, Paper, Alert } from '@mui/material';

function SafeJsonView({ data, title = "JSON Data" }) {
  if (!data || typeof data !== 'object') {
    return (
      <Box>
        <Typography variant="h6" gutterBottom>{title}</Typography>
        <Alert severity="info">No data to display</Alert>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>{title}</Typography>
      <Paper variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', maxHeight: '50vh', overflow: 'auto' }}>
        <pre style={{ margin: 0, fontSize: '0.875rem', fontFamily: 'monospace' }}>
          {JSON.stringify(data, null, 2)}
        </pre>
      </Paper>
    </Box>
  );
}

export default SafeJsonView;